import { createSlice } from '@reduxjs/toolkit';
import { fetchDiversityDistribution, fetchDrilldown } from './actions';

const constructTableWithoutBreakDown = ({
  data = [],
  headers = [],
  groupby = [],
  groupbyKey = 'dt',
  parent = null,
}) => {
  const currdata = data?.reduce?.((acc, curr) => {
    const obj = {};
    curr.forEach((element, index) => {
      obj[headers[index]] = element;
    });
    obj['group_by'] = groupby[+obj[groupbyKey]];
    if (parent) {
      obj['parent'] = parent;
    }
    return [...acc, obj];
  }, []);
  return currdata;
};

const constructTableWithBreakDown = ({
  data = [],
  headers = [],
  groupby = [],
  groupbyKey = 'dt',
  breakDown = [],
  breakDownKey = 'g2',
}) => {
  const currdata = data?.reduce?.((acc, curr) => {
    const obj = {};
    curr.forEach((element, index) => {
      obj[headers[index]] = element;
    });
    obj['group_by'] = groupby[+obj[groupbyKey]];
    obj['subRows'] = constructTableWithoutBreakDown({
      data: curr[0],
      headers: headers,
      groupby: breakDown,
      groupbyKey: breakDownKey,
      parent: groupby[+obj[groupbyKey]],
    });
    return [...acc, obj];
  }, []);

  return currdata;
};

const constructChartData = ({
  compareDate = {},
  data = [],
  headers = [],
  groupBy = [],
}) => {
  const hasCompare = compareDate?.from || compareDate?.to;
  if (!hasCompare) {
    const xdata = data?.reduce?.((acc, curr, idx) => {
      const key = groupBy[curr[1]];
      acc[key] = { y: curr[4] };
      return acc;
    }, {});

    const total = Object.values(xdata)?.reduce((acc, curr) => {
      acc += curr?.y;
      return acc;
    }, 0);

    return { total: { y: total }, ...xdata, compareDate };
  } else {
    const dataSet = data?.filter((d) => d[0] === '0');
    const cDataSet = data?.filter((d) => d[0] === '1');
    const xdata = dataSet?.reduce((acc, curr, index) => {
      const key = groupBy[curr[1]];
      const compare = cDataSet[index];
      acc[key] = { y: curr[4], c: compare?.[4] };
      return acc;
    }, {});
    const total = Object.values(xdata)?.reduce((acc, curr) => {
      acc += curr?.y;
      return acc;
    }, 0);

    const cTotal = Object.values(xdata)?.reduce((acc, curr) => {
      acc += curr?.c;
      return acc;
    }, 0);

    return { total: { y: total, c: cTotal }, ...xdata, compareDate };
  }
};

const constructDrilldownData = (payload) => {
  const k1Map = payload?.lookups?.k1;
  const k2Map = payload?.lookups?.k2;
  const returnData = payload?.table?.map((data) => {
    const [, k1, k2] = data;
    return {
      ...k1Map[k1],
      activity: k2Map[k2],
    };
  });

  return returnData;
};

const initialState = {
  isLoading: true,
  table: [],
  chart: {},
  drilldownData: [],
  drilldownIsLoading: true,
};

const { reducer } = createSlice({
  name: 'flow-health-candidate-touchpoint',
  initialState,

  reducers: {},

  extraReducers: {
    [fetchDiversityDistribution.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchDiversityDistribution.fulfilled]: (state, { payload = {} }) => {
      const { compare_date = {} } = payload;
      const chartDate = constructChartData({
        data: payload?.chart,
        headers: payload?.headers,
        groupBy: payload?.lookups?.dt,
        compareDate: compare_date,
      });
      state.chart = chartDate;
      const data = payload?.table?.length ? payload?.table : payload?.chart;
      const headers = payload?.headers;
      const groupby = payload?.lookups?.g1
        ? payload?.lookups?.g1
        : payload?.lookups?.dt;
      const groupbyKey = payload?.lookups?.g1 ? 'g1' : 'dt';
      const table = constructTableWithBreakDown({
        data,
        headers,
        groupby,
        groupbyKey,
        breakDown: payload?.lookups?.g2,
        breakDownKey: 'g2',
      });
      state.table = table;
      state.isLoading = false;
    },
    [fetchDrilldown.pending]: (state) => {
      state.drilldownIsLoading = true;
    },
    [fetchDrilldown.fulfilled]: (state, { payload = {} }) => {
      state.drilldownData = constructDrilldownData(payload);
      state.drilldownIsLoading = false;
    },
  },
});

export default reducer;
